import { HistoricOrder, HistoricModifier, Item } from 'olo-service';
import { ConciseLineItem } from './OrderHistory';

export const getConciseLineItems = (order: HistoricOrder) => {
  return order.cart.items.reduce((acc, item) => {
    const quantity = acc[item.id] ? acc[item.id].quantity : 0;

    return { ...acc, [item.id]: { ...item, quantity: quantity + 1 } };
  }, {} as Record<string, ConciseLineItem>);
};

export const getModifierPrice = (menuItem: Item, modifier: HistoricModifier) => {
  return menuItem?.modifierGroups
    ?.find((item) => item.id === modifier.modifierGroupId)
    ?.modifiers.find((item) => item.id === modifier.id)?.price || 0;
};
